export const SolutionAreasMap = {
  'Business Applications': [
    'Accelerate Revenue Generation',
    'AI Powered Business with Copilot',
    'Connected Sales and Marketing',
    'Drive Business Transformation with Copilot',
    'Enable a Resilient and Sustainable Supply Chain',
    'Innovate with AI in Low Code',
    'Modernize ERP',
    'Modernize Service',
    'Modernize the Service Experience',
    'Optimize Finance and Supply Chain',
    'Scale Business Operations',
  ],
  'Data and AI': [
    'Advance Sustainability with an Intelligent Data Platform',
    'Build and Modernize AI Apps',
    'Data Security',
    'Enable Unified Data Governance',
    'Innovate with AI and Cloud Scale Databases in Every App',
    'Innovate with Azure AI Platform',
    'Migrate and Modernize Your Data Estate',
    'Migrate and Secure Windows Server SQL and Linux Estate',
    'Migrate Oracle',
    'Unify Your Intelligent Data and Analytics Platform',
  ],
  'Digital and Application Innovation': [
    'Accelerate Developer Productivity',
    'Accelerate Innovation with Integration Services',
    'Accelerate Innovation with Low Code',
    'Build and Modernize AI Apps',
    'Build your Games in the Cloud with Azure',
    'Enable Developer Productivity and Accelerate Delivery',
    'Innovate and Scale with Cloud Native Apps',
    'Migrate Enterprise Apps',
    'Modernize Enterprise Applications',
  ],
  Infrastructure: [
    'Enable Customer Success',
    'Innovate Across Hybrid and Edge with Arc and IoT',
    'Innovate with Azure AI Platform',
    'Innovate with HPC',
    'MACC Accelerate Growth with Microsoft Azure Consumption Commitments',
    'Migrate and Modernize your Infrastructure and Workloads',
    'Migrate and Secure Windows Server SQL and Linux Estate',
    'Migrate Linux Estate',
    'Migrate Oracle',
    'Migrate SAP',
    'Modernize SAP on the Microsoft Cloud',
    'Modernize your Workloads with Azure at any Scale with HPC plus AI',
    'Modernizing Mainframe',
    'Protect your Data and Ensure Business Resiliency with BCDR',
  ],
  'Modern Work': [
    'AI Powered Business with Copilot',
    'Cloud Endpoints',
    'Collaborative Apps',
    'Converged Communications',
    'Converged Communications Teams Phone',
    'Converged Communications Teams Rooms',
    'Data Security',
    'Digital Workforce',
    'Drive Business Transformation with Copilot',
    'Employee Experience',
    'Frontline Workers',
    'Modernize with Surface',
    'NextGen Windows Experiences',
    'Refresh your Devices',
    'Secure Productivity',
  ],
  Security: [
    'Advanced Identity',
    'Copilot for Security',
    'Data Governance',
    'Data Security',
    'Defend Against Threats with SIEM Plus XDR',
    'Migrate and Secure Windows Server SQL and Linux Estate',
    'Mitigate Compliance and Privacy Risks',
    'Modern Sec Ops',
    'Multi Cloud Security',
    'Protect and Govern Sensitive Data',
    'Secure Identities and Access',
    'Secure Multi Cloud Environments',
    'Secure Productivity',
    'Threat protection',
  ],
  'Unified Support': [
    'Accelerate AI innovation for Digital Natives with Unified',
    'Build a Strong Foundation with Unified',
    'Drive Cloud Success with Enhanced Solutions',
    'Scale Unified through Partner',
  ],
} as const;

export type SolutionAreasType = keyof typeof SolutionAreasMap;
export const SolutionAreasList = Object.keys(
  SolutionAreasMap,
) as SolutionAreasType[];

export const SolutionAreasListOptions = SolutionAreasList.map((x) => ({
  title: x,
  value: x,
}));
